<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="370"
    :oneOption="true"
    :pendingOption="false"
    :sq_numberData="'sq_fiftyData'"
    :sqOptions="[51]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFifty',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 90)
      } else if (value === 3) {
        this.$emit('handleProgress', 89)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
